import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Avatar } from '@aimsos/ui';

import { formatActivityTimestamp } from '../../utils/groupActivityByDate.js';
import { typeInitials } from '../../utils/typeInitials.js';

/** One comment in a note's thread: who, when, what. */
const NoteCommentItem = memo(function NoteCommentItem({ comment }) {
  const { i18n } = useTranslation('unified-profiles');
  const name = comment.author?.name ?? '';

  return (
    <li data-testid="note-comment" className="flex items-start gap-3">
      <Avatar size="md" initials={typeInitials(name)} alt={name} />
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        <div className="flex flex-wrap items-baseline gap-2">
          <span className="text-sm font-semibold text-content">{name}</span>
          {comment.createdAt ? (
            <time dateTime={comment.createdAt} className="text-xs text-content-muted">
              {formatActivityTimestamp(comment.createdAt, i18n?.language)}
            </time>
          ) : null}
        </div>
        <p className="whitespace-pre-wrap break-words text-sm text-content-secondary">{comment.text}</p>
      </div>
    </li>
  );
});

export default NoteCommentItem;
